import config from "@Config/index";
import axios from "axios";

const fetchReviewMedia = async ({ id, selectedLang }: any) => {
  const params = {
    page: 1,
    limit: 50,
    lang: selectedLang,
  };

  return axios.get(`${config.API_URL}/api/v0/inventories/${id}/reviews/media`, {
    params,
    ...config.apiParams,
  });
};

export default fetchReviewMedia;
